import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountAccessDeniedComponent } from './components/account-access-denied.component';
//DevExpress
//Base
//AccessDenied

@NgModule({
    declarations: [
        AccountAccessDeniedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [AccountAccessDeniedComponent],
    providers: []
})

export class AccessDeniedModule {
}